import React from 'react';
import PropTypes from 'prop-types';

import * as SharedZoneProductGoods from 'store/SharedZone/blocks/goods/selectors';

function GoodsDayLabel({ label, className }) {
  return <div className={className}> {label} </div>;
}

GoodsDayLabel.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

const mapStateToProps = (state) => ({
  label: SharedZoneProductGoods.getLabel(state),
});

export default SharedZoneProductGoods.connect(mapStateToProps)(GoodsDayLabel);
